import Tippy from '@tippyjs/react';
import styled from 'styled-components';
import colors from 'styles/colors';
import sizes from 'styles/sizes';
import { BrandCode } from 'types';

export const StyledTippy = styled(Tippy)`
	/* Ratings Modal Container */
	&.tippy-box[data-theme='WithArrow'] {
		&.additional-translate {
			transform: translateX(18%);
			@media (min-width: ${sizes.media.mediumMinWidth}px) {
				transform: translateX(10%);
			}
		}

		&.isPanel {
			transform: translateX(5%);
		}

		&.cruiseCard {
			position: absolute;
			left: -157px;

			/* 40px - to account for larger screens on newer models for Ratings Modal */
			@media (min-width: ${sizes.media.xxSmallMaxWidth}px) {
				${({ brand }) =>
					({
						[BrandCode.Celebrity]: `
            left: -160px;
          `,
					})[brand]}
			}

			@media (min-width: ${sizes.media.xSmallMaxWidth + 40}px) {
				left: -128px;
			}
		}
	}

	/* Tooltip with down arrow */
	&.tippy-box[data-placement='bottom'][data-theme='WithArrow']::after {
		content: '';
		width: 16px;
		height: 16px;

		background: ${colors.primary.ice};
		position: absolute;

		transform: rotate(-45deg);
		top: -8px;
		left: calc(45%);
		border-top: 1px solid ${colors.functional.borderGrey};
		border-right: 1px solid ${colors.functional.borderGrey};
	}

	&.tippy-box.rating.isPanel[data-placement='bottom'][data-theme='WithArrow']::after {
		left: calc(33% + 25px);
	}

	&.tippy-box.rating[data-placement='bottom'][data-theme='WithArrow']::after {
		left: calc(45%);
	}

	&.tippy-box[data-placement='bottom-start'][data-theme='WithArrow']::after {
		content: '';
		width: 16px;
		height: 16px;

		background: ${colors.primary.ice};
		position: absolute;
		box-shadow: inset -1px 1px 1px ${colors.functional.borderGrey};
		transform: rotate(-45deg);
		top: -8px;
		left: calc(0% + 12px);
		border-top: 1px solid ${colors.functional.borderGrey};
		border-right: 1px solid ${colors.functional.borderGrey};
	}

	&.tippy-box[data-placement='bottom-end'][data-theme='WithArrow']::after {
		content: '';
		width: 16px;
		height: 16px;

		background: ${colors.primary.ice};
		position: absolute;
		box-shadow: inset -1px 1px 1px ${colors.functional.borderGrey};
		transform: rotate(-45deg);
		top: -8px;
		left: calc(100% - 28px);
		border-top: 1px solid ${colors.functional.borderGrey};
		border-right: 1px solid ${colors.functional.borderGrey};
	}

	&.tippy-box[data-placement='bottom-end'][data-theme='WithArrow']::after {
		content: '';
		width: 16px;
		height: 16px;

		background: ${colors.primary.ice};
		position: absolute;
		box-shadow: inset -1px 1px 1px ${colors.functional.borderGrey};
		transform: rotate(-45deg);
		top: -8px;
		left: calc(100% - 28px);
		border-top: 1px solid ${colors.functional.borderGrey};
		border-right: 1px solid ${colors.functional.borderGrey};
	}

	&.isPanel.tippy-box[data-placement='bottom-end'][data-theme='WithArrow']::after {
		left: calc(100% - 100px);
	}

	&.tippy-box[data-placement='top'][data-theme='WithArrow']::after {
		content: '';
		width: 16px;
		height: 16px;

		background: ${colors.primary.ice};
		position: absolute;
		box-shadow: inset -1px 1px 1px ${colors.functional.borderGrey};
		transform: rotate(-225deg);
		top: calc(100% - 8px);
		left: calc(50% - 17px);
		border-top: 1px solid ${colors.functional.borderGrey};
		border-right: 1px solid ${colors.functional.borderGrey};
	}

	&.tippy-box.rating[data-placement='top'][data-theme='WithArrow']::after {
		left: calc(45%);
	}

	&.tippy-box[data-placement='top-start'][data-theme='WithArrow']::after {
		content: '';
		width: 16px;
		height: 16px;

		background: ${colors.primary.ice};
		position: absolute;
		box-shadow: inset -1px 1px 1px ${colors.functional.borderGrey};
		transform: rotate(-225deg);
		top: calc(100% - 8px);
		left: calc(50% - 30%);
		border-top: 1px solid ${colors.functional.borderGrey};
		border-right: 1px solid ${colors.functional.borderGrey};
	}

	&.tippy-box[data-placement='top-end'][data-theme='WithArrow']::after {
		content: '';
		width: 16px;
		height: 16px;

		background: ${colors.primary.ice};
		position: absolute;
		box-shadow: inset -1px 1px 1px ${colors.functional.borderGrey};
		transform: rotate(-225deg);
		top: calc(100% - 8px);
		left: calc(100% - 28px);
		border-top: 1px solid ${colors.functional.borderGrey};
		border-right: 1px solid ${colors.functional.borderGrey};
	}

	&.tippy-box[data-placement='right'][data-theme='WithArrow']::after {
		content: '';
		width: 16px;
		height: 16px;

		background: ${colors.primary.ice};
		position: absolute;
		box-shadow: inset -1px 1px 1px ${colors.functional.borderGrey};
		transform: rotate(-135deg);
		left: calc(0% - 8px);
		top: calc(50% - 8px);
		border-top: 1px solid ${colors.functional.borderGrey};
		border-right: 1px solid ${colors.functional.borderGrey};
	}

	&.tippy-box[data-placement='right-start'][data-theme='WithArrow']::after {
		content: '';
		width: 16px;
		height: 16px;

		background: ${colors.primary.ice};
		position: absolute;
		box-shadow: inset -1px 1px 1px ${colors.functional.borderGrey};
		transform: rotate(-135deg);
		left: calc(0% - 8px);
		top: calc(50% - 35%);
		border-top: 1px solid ${colors.functional.borderGrey};
		border-right: 1px solid ${colors.functional.borderGrey};
	}

	&.tippy-box[data-placement='right-end'][data-theme='WithArrow']::after {
		content: '';
		width: 16px;
		height: 16px;

		background: ${colors.primary.ice};
		position: absolute;
		box-shadow: inset -1px 1px 1px ${colors.functional.borderGrey};
		transform: rotate(-135deg);
		left: calc(0% - 8px);
		top: calc(80%);
		border-top: 1px solid ${colors.functional.borderGrey};
		border-right: 1px solid ${colors.functional.borderGrey};
	}

	&.tippy-box[data-placement='left'][data-theme='WithArrow']::after {
		content: '';
		width: 16px;
		height: 16px;

		background: ${colors.primary.ice};
		position: absolute;
		box-shadow: inset -1px 1px 1px ${colors.functional.borderGrey};
		transform: rotate(45deg);
		left: calc(100% - 8px);
		top: calc(50% - 8px);
		border-top: 1px solid ${colors.functional.borderGrey};
		border-right: 1px solid ${colors.functional.borderGrey};
	}

	&.tippy-box[data-placement='left-start'][data-theme='WithArrow']::after {
		content: '';
		width: 16px;
		height: 16px;

		background: ${colors.primary.ice};
		position: absolute;
		box-shadow: inset -1px 1px 1px ${colors.functional.borderGrey};
		transform: rotate(45deg);
		left: calc(100% - 8px);
		top: calc(50% - 35%);
		border-top: 1px solid ${colors.functional.borderGrey};
		border-right: 1px solid ${colors.functional.borderGrey};
	}

	&.tippy-box[data-placement='left-end'][data-theme='WithArrow']::after {
		content: '';
		width: 16px;
		height: 16px;

		background: ${colors.primary.ice};
		position: absolute;
		box-shadow: inset -1px 1px 1px ${colors.functional.borderGrey};
		transform: rotate(45deg);
		left: calc(100% - 8px);
		top: calc(80%);
		border-top: 1px solid ${colors.functional.borderGrey};
		border-right: 1px solid ${colors.functional.borderGrey};
	}
`;

export const TipperTooltip = styled.div`
	line-height: 1.4;
	background: ${colors.primary.ice};
	border: 1px solid ${colors.functional.borderGrey};
	box-sizing: border-box;
	padding: 15px 20px;
	border-radius: 5px;
	box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.16);
	text-align: left;

	/* Ratings Modal */
	&.rating {
		max-width: 259px;

		${({ theme }) =>
			({
				[BrandCode.Celebrity]: `
        max-height: 247px;
      `,
				[BrandCode.RoyalCaribbean]: `
        max-height: 241px;
      `,
			})[theme.brandCode]}
	}
`;

export const TipperContent = styled.span`
	margin: 0;
	padding: 0;
	text-align: left;
	display: inline-block;

	[data-tippy-root] {
		top: -8px;
	}

	h5 {
		font-size: 1rem;
		line-height: 1.32em;
		margin-bottom: 0.667em;
	}
`;

export const WrapperButton = styled.div`
	align-items: start;
	display: flex;
	justify-content: space-between;
	width: 100%;
`;
